import { render, staticRenderFns } from "./adjustments.vue?vue&type=template&id=35fba6e6&scoped=true&"
import script from "./adjustments.vue?vue&type=script&lang=js&"
export * from "./adjustments.vue?vue&type=script&lang=js&"
import style0 from "./adjustments.vue?vue&type=style&index=0&id=35fba6e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fba6e6",
  null
  
)

export default component.exports